// Used a separate file for bundling

export function isTextSizePanelSupported(
	zone: eXpress.core.IZone | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	return dashboard.canSetFontSize(zone);
}
